var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseSubtract = function SvgCloseSubtract(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 9,
    fill: "none",
    viewBox: "0 0 9 9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M4.5 0a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m0 3.793-2-2-.707.707 2 2-2 2 .707.707 2-2 2 2 .707-.707-2-2 2-2-.707-.707z"
  })));
};
export default SvgCloseSubtract;